export type ColorMap = Record<string, string>;

export const DEFAULT_STATUS_COLORS: ColorMap = {
  active: 'bg-green-500/10 text-green-400 border-green-500/20',
  idle: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
  maintenance: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  scheduled: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
  loading: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  in_transit: 'bg-green-500/10 text-green-400 border-green-500/20',
  delivered: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  cancelled: 'bg-red-500/10 text-red-400 border-red-500/20',
};

export const DEFAULT_SEVERITY_COLORS: ColorMap = {
  low: 'bg-slate-500/10 text-slate-400 border border-slate-500/20',
  medium: 'bg-amber-500/10 text-amber-400 border border-amber-500/20',
  high: 'bg-orange-500/10 text-orange-400 border border-orange-500/20',
  critical: 'bg-red-500/10 text-red-400 border border-red-500/20',
};

export function statusBadge(status: string, colors: ColorMap = DEFAULT_STATUS_COLORS): string {
  const label = status.replace(/_/g, ' ');
  const cls = colors[status] || colors.active || 'bg-slate-500/10 text-slate-400 border-slate-500/20';
  return `<span class="inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold rounded-lg border ${cls}"><span class="w-1.5 h-1.5 rounded-full bg-current opacity-70"></span>${label}</span>`;
}

export function severityBadge(severity: string, colors: ColorMap = DEFAULT_SEVERITY_COLORS): string {
  const cls = colors[severity] || '';
  return `<span class="inline-flex px-2 py-0.5 text-[11px] font-semibold rounded-lg ${cls}">${severity}</span>`;
}
